import ApiService from './';
import { PushLeadToPipelineParams } from '@params/redux/leads';
/**
 * @heading1: Folder API service.
 * @paragraph: This module provides a set of methods to interact with the Folder API.
 * It handles operations like Fetching folder details and create folder.
 */
const LeadApi = {
    /**
     * @heading3: Fetch Folders
     * @paragraph: Sends a POST request to retrieve all folders available for the user.
     * @param: {string} token - The user's authentication token.
     * @param: {number} client_id - The parameters required id on which the folders will be fetch.
     * @returns: {Promise<unknown[]>} - The response containing a list of all folders.
     * @separator:
     */
    fetchLeads: (token: string, client_id: number) => {
        // Perform a POST request to fetch folders with the provided data
        return ApiService.apiHit({
            url: 'get-leads',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    pushLeadToPipeline: (token: string, data: PushLeadToPipelineParams) => {
        // Perform a POST request to push a lead to a pipeline with the provided data
        return ApiService.apiHit({
            url: 'lead-push-to-pipeline',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    deleteLead: (token: string, lead_result_id_array: number[]) => {
        // Perform a POST request to push a lead to a pipeline with the provided data
        return ApiService.apiHit({
            url: 'delete-lead',
            method: 'post',
            token,
            data: { lead_result_id_array },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchHotLeads: (token: string) => {
        // Perform a POST request to push a lead to a pipeline with the provided data
        return ApiService.apiHit({
            url: 'get-incoming-leads',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    saveMappingLeads: (token: string, data: Record<string, unknown>) => {
        // Perform a POST request to push a lead to a pipeline with the provided data
        return ApiService.apiHit({
            url: 'save-mapping-lead',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default LeadApi;
